module.exports = __webpack_public_path__ + "img/MOUSTACHES SET 3.ea79a17.svg";